import React, { FC } from 'react';
// Misc
import './ErrorMessage.scss';

export const ErrorMessage: FC<any> = ({errors, name}) => {

    if (!errors[name]) return null;

    return (
        <div className="errorMessage">
            {errors[name].message}
        </div>
    )
}